import { render, staticRenderFns } from "./request-payment-review.vue?vue&type=template&id=f50fba66&scoped=true"
import script from "./request-payment-review.vue?vue&type=script&lang=js"
export * from "./request-payment-review.vue?vue&type=script&lang=js"
import style0 from "./request-payment-review.vue?vue&type=style&index=0&id=f50fba66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f50fba66",
  null
  
)

export default component.exports